import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useApp } from "@/context/AppContext";

export const ConfirmDialog = ({ open, onOpenChange, title, lines = [], onYes, busy, danger, children }) => {
  const { t } = useApp();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-[92vw] sm:max-w-sm rounded-3xl" data-testid="confirm-dialog">
        <AlertDialogHeader className="text-left">
          <AlertDialogTitle className="font-display text-xl text-[#0D3B2B]" data-testid="confirm-dialog-title">{title}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-[#4A6358] text-sm">
              {lines.map((l, i) => <p key={i} className="rounded-xl bg-[#F4F8F5] px-3 py-2">{l}</p>)}
            </div>
          </AlertDialogDescription>
          {children}
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-row gap-3 sm:space-x-0">
          <AlertDialogCancel data-testid="confirm-no-btn" className="flex-1 h-12 mt-0 rounded-2xl text-base">{t("No")}</AlertDialogCancel>
          <button
            data-testid="confirm-yes-btn"
            disabled={busy}
            onClick={onYes}
            className={`flex-1 h-12 rounded-2xl text-base font-semibold text-white transition-transform active:scale-95 disabled:opacity-60 ${danger ? "bg-[#E05C3A]" : "bg-[#0D3B2B]"}`}
          >
            {busy ? t("Please wait…") : t("Yes")}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
